import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Claire Landais Sauvage - Céramiste et Poète",
  description = "Des bols simples, créés lentement, avec des argiles glanées dans la nature et cuits en four à bois, pour une communion avec le monde vivant.",
  keywords = "céramique, poésie, bols, artisanat, argile naturelle, four à bois, Claire Landais, art, transmission",
  image = "https://clairelandaissauvage.fr/intro2.jpg",
  url = "https://clairelandaissauvage.fr/",
  type = "website"
}) => {
  return (
    <Helmet>
      {/* Titre de la page */}
      <title>{title}</title>
      
      {/* Meta tags de base */}
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEO;